import React, { useState, useEffect } from "react";
// import { DataTable } from "primereact/datatable";
// import Loading from "../../components/Loading";
import Loading from "../components/Loading.jsx";
import DataTable from "react-data-table-component";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { TfiMenuAlt } from "react-icons/tfi";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
// import { Pagination } from "flowbite-react";


const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    return (
        <div className="flex justify-center gap-4 mt-4">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Previous
            </button>

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Next
            </button>
        </div>
    );
};

export default function AccountsTable() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [leads, setLeads] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDropdown, setOpenDropdown] = useState(null);  // Track open dropdown
    const [formData, setFormData] = useState({}); // Store lead form data
    const [editingId, setEditingId] = useState(null);
    
    const openModal = () => {
        console.log("Opening modal...");
        setPrevSelectedColumns(selectedColumnsContact); // Save current state before changes
        setIsModalOpen(true);
    };

    const columns = [
        // {
        //     name: (
        //         <div style={{

        //         }}
        //         >
        //             <FaBars
        //                 className="text-lg cursor-pointer hover:text-blue-500"
        //                 onClick={openModal}
        //             />
        //         </div>
        //     ),
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        // },
        {
            name: "Account Name",
            selector: row => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out"
                    }}
                    onMouseEnter={e => e.target.style.color = "blue"}
                    onMouseLeave={e => e.target.style.color = "#5A5A5C"}
                    onClick={() => navigate(`/account-details/${row.id}`)}
                >
                    {row.Account_Name}
                </span>
            ),
            sortable: true,
            style: { fontSize: 16, color: "#5A5A5C" }
        },
        { name: "Phone", selector: row => row.Phone, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        { name: "Website", selector: row => row.Website, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        { name: "Owner", selector: row => row.Owner, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        { name: "Created By", selector: row => row.Created_By, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // {
        //     name: "Action",
        //     cell: rowData => actionTemplate(rowData),
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        //     style: { fontSize: 16 }
        // }


    ];


       const [isModalOpen, setIsModalOpen] = useState(false);
        // const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.name)); // Default: Show all columns
        const [searchTerm, setSearchTerm] = useState("");
        const [selectedColumnsContact, setSelectedColumnsContact] = useState([]);
    
    
        // State to track the most recently clicked column
        const [lastClickedColumn, setLastClickedColumn] = useState(null);
        const [initialColumnsContact, setInitialColumnsContact] = useState([]); // Track initial columns state
    
    
        // Fetch columns from localStorage or default columns when component mounts
        useEffect(() => {
            const storedColumns = localStorage.getItem("selectedColumnsContact");
    
            if (storedColumns) {
                // If columns are found in localStorage, use them
                const parsedColumns = JSON.parse(storedColumns);
                setSelectedColumnsContact(parsedColumns);
                setInitialColumnsContact(parsedColumns); // Save the initial state
            } else {
                // Otherwise, use default columns (this is assuming 'columns' is your default set)
                const defaultColumns = columns.map(col => col.name);
                setSelectedColumnsContact(defaultColumns);
                setInitialColumnsContact(defaultColumns); // Save the initial state
            }
        }, []);
    
        // Function to handle column changes
        const handleColumnChange = (colName) => {
            setSelectedColumnsContact((prev) => {
                const updatedColumns = prev.includes(colName)
                    ? prev.filter((name) => name !== colName)
                    : [...prev, colName];
    
                try {
                    // Ensure only primitive values (strings) are stored
                    const safeColumns = updatedColumns.map(col => String(col));
                    localStorage.setItem("selectedColumnsContact", JSON.stringify(safeColumns));
                } catch (error) {
                    console.error("Error saving to localStorage:", error);
                }
    
                // Track the most recent checkbox clicked
                setLastClickedColumn(colName);
    
                return updatedColumns;
            });
        };
    
    
        // Function to apply filters (save to localStorage)
        const applyFilter = () => {
            try {
                // Ensure only primitive values (strings) are stored
                const safeColumns = selectedColumnsContact.map(col => String(col));
                localStorage.setItem("selectedColumnsContact", JSON.stringify(safeColumns));
            } catch (error) {
                console.error("Error saving to localStorage:", error);
            }
    
            setIsModalOpen(false);
        };
    
        const [prevSelectedColumns, setPrevSelectedColumns] = useState([]); // Store previous state
    
    
    
        // Function to reset filter by restoring the saved state
        const resetFilter = () => {
            setSelectedColumnsContact(prevSelectedColumns); // Restore previous selection
            setIsModalOpen(false);
        };
    
    
        const filteredColumns = columns.filter(
            col => selectedColumnsContact.includes(col.name) || typeof col.name === "object"
        );


    const [isFetched, setIsFetched] = useState(false);

    useEffect(() => {
        const fetchLeadValues = async () => {
            setIsLoading(true); // Start loading
            try {
                const response = await fetch("/server/dealer_backend/getAllAccounts");
                const data = await response.json();

                if (data.status === "success") {
                    setLeads(data.data);
                } else {
                    console.error("Failed to fetch leads:", data.error);
                }
            } catch (error) {
                console.error("Error fetching leads:", error);
            } finally {
                setIsLoading(false); // End loading
                setIsFetched(true);  // Mark fetch as complete
            }
        };
        fetchLeadValues();
    }, []);

    const totalPages = Math.ceil(leads.length / rowsPerPage);
    const onPageChange = (page) => setCurrentPage(page);
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1);
    };

    const handleViewClick = (rowData, field) => {
        if (field === "Account_Name") {
            navigate(`/contact-details/${rowData.id}`);
        }
    };




    const handleEditClick = async (rowData) => {
        // setFormData(rowData); // Populate form with existing data before editing
        // setEditingId(rowData.id); // Store the ID of the lead being edited
        navigate(`/contact-edit/${rowData.id}`);
    };



    const actionTemplate = (rowData) => (
        <div className="flex gap-2">
            <button className="text-blue-500" onClick={() => handleViewClick(rowData, "Account_Name")}>
                <FaEye />
            </button>
            <button className="text-green-500" onClick={() => handleEditClick(rowData)}>
                <FaEdit />
            </button>

            {/* <button className="text-red-500" onClick={() => console.log("Delete", rowData.id)}>
                <FaTrash />
            </button> */}
        </div>
    );



    return (
        <div>
             {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm" onClick={(e) => e.stopPropagation()}>
                        <h2 className="text-xl font-bold mb-4">Manage Columns</h2>

                        {/* Search Box */}
                        <input
                            type="text"
                            placeholder="Search"
                            className="w-full p-2 border rounded mb-2"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        {/* Column Selection */}
                        {/* Column Selection */}
                        <div className="max-h-60 overflow-auto">
                            {columns
                                .filter(col => typeof col.name === "string")
                                .filter(col => col.name.toLowerCase().includes(searchTerm.toLowerCase()))
                                .map((col, index) => {
                                    const isLastName = col.name === "Last Name";
                                    return (
                                        <label key={index} className="flex items-center mb-2">
                                            <input
                                                type="checkbox"
                                                checked={selectedColumnsContact.includes(col.name)}
                                                onChange={() => {
                                                    if (!isLastName) {
                                                        handleColumnChange(col.name);
                                                    }
                                                }}
                                                disabled={isLastName} // Prevent deselection
                                                className="mr-2"
                                            />
                                            {col.name}
                                        </label>
                                    );
                                })}
                        </div>



                        {/* Buttons */}
                        <div className="flex justify-end mt-4 gap-2">
                            <button className="px-4 py-2 bg-red-500 text-white rounded" onClick={resetFilter}>Cancel</button>
                            <button className="px-4 py-2 bg-blue-500 text-white rounded" onClick={applyFilter}>Save</button>
                        </div>
                    </div>
                </div>
            )}
            <h2 className="table-title"></h2>
            <div className="leads-content">


                <div className="table-header flex justify-between items-center p-4">



                    {/* FaBars icon button */}
                    <div
                        className="p-2 bg-white rounded-md shadow cursor-pointer hover:text-blue-500 transition mt-[12px] mr-[12px]"
                        onClick={openModal}
                        
                    >
                        <TfiMenuAlt className="text-xl text-blue-500" />

                    </div>



                    {/* Add Lead button */}
                    
                </div>

                {/* Apply a larger font size */}


                {/* Show Loading */}
                {isLoading ? (
                    <div className="flex justify-center items-center gap-2 py-6 text-blue-500">
                        <svg
                            className="animate-spin h-5 w-5 text-blue-500"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            ></path>
                        </svg>
                        <span>Loading Data...</span>
                    </div>

                ) : leads.length === 0 ? (
                    <div className="text-center py-6 text-blue-500">No donors available</div>
                ) : (
                    <>
                        <DataTable
                            columns={filteredColumns}
                            data={leads.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)}
                            fixedHeader
                            className="custom-table text-lg"
                            customStyles={{
                                headCells: {
                                    style: {
                                        fontSize: "16px",
                                        fontWeight: "500",
                                    },
                                },
                                cells: {
                                    style: {
                                        whiteSpace: "nowrap",
                                        overflow: "visible",
                                    },
                                },
                            }}
                        />

                        {/* Show Pagination only when leads are loaded */}
                        <div className="table-footer mt-4 flex flex-wrap justify-between items-center">
                            <span className="pagination-info">
                                {`Showing ${Math.min((currentPage - 1) * rowsPerPage + 1, leads.length)} 
                                to ${Math.min(currentPage * rowsPerPage, leads.length)} 
                                of ${leads.length} Entries`}
                            </span>

                            <span className="rows-per-page flex items-center gap-2">
                                <label className="text-gray-700 font-medium">Records per page</label>
                                <select
                                    value={rowsPerPage}
                                    onChange={handleRowsPerPageChange}
                                    className="border rounded px-1 text-gray-700 focus:outline-none"
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={15}>15</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                </select>
                            </span>

                            <Pagination
                                layout="navigation"
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={onPageChange}
                            />
                        </div>
                    </>
                )}

            </div>
        </div>
    );
}
